import Moment from "moment";

// All links stop working at this moment (midnight NZDT).
export const LINK_EXPIRY = Moment("2026-11-10T00:00:00+13:00");

export function msUntilExpiry() {
  return LINK_EXPIRY.diff(Moment());
}

export function isLinkExpired() {
  return msUntilExpiry() <= 0;
}

export function daysUntilExpiry() {
  return Math.max(0, Math.ceil(msUntilExpiry() / (24 * 60 * 60 * 1000)));
}
